export function cnv_pixel(...args) {
	console.log(`cnv_pixel`, args)
}
export function ym(...args) {
	console.log(`ym`, args)
}
export function rstat(...args) {
	console.log(`rstat`, args)
}
export function rstat4(...args) {
	console.log(`rstat4`, args)
}